import React, { } from 'react'
import styles from './SubModal.module.css'
import { Modal } from 'react-bootstrap';
import { IoCloseOutline } from "react-icons/io5";

const SubModal = (props) => {
    const { children, onHide, modalTitle, landscapeMode = false } = props
    return (
        <Modal show={true} onHide={onHide} dialogClassName={`${styles[`crm-submodal`]} ${landscapeMode && styles['crm-submodal--landscape-mode']}`} size="xl" centered aria-labelledby="contained-modal-title-vcenter" className={`rtl-modal`} >
            <Modal.Header className={`${styles['submodal-header']}`}>
                <Modal.Title>{modalTitle}</Modal.Title>
                <IoCloseOutline className={styles['close-submodal-icon']} onClick={onHide} />
            </Modal.Header>
            <Modal.Body id='file-manager-model' className={`${styles[`submodal-body`]} ${landscapeMode && styles['submodal-body--landscape-mode']}`} >
                {
                    children
                }
            </Modal.Body>
            {/* <Modal.Footer className={`${styles['modal-footer']}`}>
            
                </Modal.Footer> */}
        </Modal>
    )
}

export default SubModal